var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMinSize, IsArray, IsBoolean, IsDateString, IsOptional, IsUUID, } from 'class-validator';
/**
 * Patient request to place a *pass* of pending holds against a plan (PRD #1343,
 * RS-004). The patient sends ONLY the plan and the chosen slot starts — the
 * therapist, treatment, duration, next unbooked units and office are all
 * re-derived and re-validated server-side. Each `start` is re-checked against a
 * fresh slot search; if any were taken meanwhile the endpoint returns a typed
 * `409` conflict carrying the taken starts (see {@link PatientBookingConflictCode}),
 * so the caller can drop them and resubmit. The batch is hard-capped at the
 * plan's remaining allowance — no over-plan (Mehrleistung) booking is
 * patient-triggerable. All created holds share one `bookingPassId`.
 */
export class CreatePatientBookingBatchDto {
    treatmentPlanId;
    starts;
    /**
     * Therapist preference (RS-007), applied to every hold in the pass. Omitted →
     * the plan's continuity therapist. A specific id books that therapist for all
     * slots; `anyTherapist` auto-preselects a therapist free at each slot's time
     * and stamps the "egal" marker.
     */
    therapistId;
    anyTherapist;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreatePatientBookingBatchDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(1),
    IsDateString({}, { each: true }),
    __metadata("design:type", Array)
], CreatePatientBookingBatchDto.prototype, "starts", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePatientBookingBatchDto.prototype, "therapistId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreatePatientBookingBatchDto.prototype, "anyTherapist", void 0);
//# sourceMappingURL=create-patient-booking-batch.dto.js.map